class SplitBehaviorTypes {
	static None = 0;
	static MasterSilent = 1;
	static MasterAudio = 2;
	static MasterMonitor = 3;

	static getArray() {
		return Object.keys(this).map((t, i) => {
			return {
				title: t.split(/(?<=[a-z])(?=[A-Z])/).join(" "),
				value: Object.values(this)[i]
			}
		});
	}
}

export default SplitBehaviorTypes;